'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { useIsMounted } from 'usehooks-ts';
import { type CurrencySymbols } from '@/features/currency/types/currency-types';
import ListingDetailed from '@/features/listing/components/listing-detailed/listing-detailed';
import useLoadListings from '@/features/listing/hooks/use-load-listings';
import { type ListingType } from '@/features/listing/types/listing-types';
import { type Place } from '@/features/place/types/place-types';
import Divider from '@/ui/divider/divider';
import Loader from '@/ui/loader/loader';
import styles from './listing-detailed-infinity-loader.module.scss';
interface ListingsDetailedInfinityScrollProps {
  listingType: ListingType;
  placeBbox: Place['bbox'];
  currencyName: CurrencySymbols['name'];
  wrapperClassName?: string;
}
export default function ListingsDetailedInfinityScroll(props) {
  const $ = _c(19);
  const {
    currencyName,
    listingType,
    placeBbox,
    wrapperClassName
  } = props;
  const isMounted = useIsMounted();
  const {
    error,
    hasNextPage,
    listings,
    loadMoreListings,
    loading
  } = useLoadListings(listingType, placeBbox, currencyName);
  const t0 = !!error;
  let t1;
  if ($[0] !== hasNextPage || $[1] !== loadMoreListings || $[2] !== loading || $[3] !== t0) {
    t1 = {
      disabled: t0,
      hasNextPage,
      loading,
      onLoadMore: loadMoreListings,
      rootMargin: "0px 0px 400px 0px"
    };
    $[0] = hasNextPage;
    $[1] = loadMoreListings;
    $[2] = loading;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [sentryRef] = useInfiniteScroll(t1);
  let t2;
  if ($[5] !== isMounted) {
    t2 = [isMounted];
    $[5] = isMounted;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(_temp2, t2);
  let t3;
  if ($[7] !== listings || $[8] !== wrapperClassName) {
    let t4;
    if ($[10] !== wrapperClassName) {
      t4 = listing => <div id={String(listing.id)} key={listing.id}><div className={wrapperClassName}><ListingDetailed listing={listing} /></div><Divider /></div>;
      $[10] = wrapperClassName;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = listings.map(t4);
    $[7] = listings;
    $[8] = wrapperClassName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[12] !== hasNextPage || $[13] !== loading || $[14] !== sentryRef) {
    t4 = (loading || hasNextPage) && <div className={styles.listingsDetailedInfinityScroll_loader} ref={sentryRef}><Loader /></div>;
    $[12] = hasNextPage;
    $[13] = loading;
    $[14] = sentryRef;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp2() {
  const handlePopState = _temp;
  globalThis.addEventListener("popstate", handlePopState);
  return () => {
    globalThis.removeEventListener("popstate", handlePopState);
  };
}
function _temp() {
  const windowPathname = globalThis.location.pathname;
  const windowCurrentId = windowPathname.split("/listings/")[1];
  setTimeout(() => {
    const listingElement = document.getElementById(windowCurrentId);
    if (listingElement) {
      const rect = listingElement.getBoundingClientRect();
      const scrollTop = window.scrollY + rect.top - 85;
      window.scrollTo({
        behavior: "smooth",
        top: scrollTop
      });
    }
  }, 50);
}